const productsSections = document.querySelectorAll<HTMLElement>(".s-products")

productsSections.forEach((section) => {
  const items = section.querySelectorAll<HTMLElement>(".g-products .i-product")
  const loadMoreButton = section.querySelector<HTMLElement>(".--js-products-load-more")
  const paginationActiveItemsNumber = section.querySelector<HTMLElement>(".i-pagination__active-items")
  const currentUrl = new URL(window.location.href)
  let scrollYValue: number = currentUrl.searchParams.get("y") ? Number(currentUrl.searchParams.get("y")) : 0

  const getParamsHandler = () => {
    if (!loadMoreButton) return

    let listingProductsNumber = Number(currentUrl.searchParams.get("limit"))
    const onloadActiveItemsNumber = Number(loadMoreButton.dataset.activeItemsNumber)
    const totalItemsNumber = Number(loadMoreButton.dataset.totalItemsNumber)

    if (!paginationActiveItemsNumber || !listingProductsNumber || listingProductsNumber <= onloadActiveItemsNumber) return

    if (listingProductsNumber >= totalItemsNumber) {
      listingProductsNumber = totalItemsNumber
      currentUrl.searchParams.set("limit", `${totalItemsNumber.toString()}`)
      window.history.pushState({}, "", currentUrl.toString())
      loadMoreButton.remove()
    }

    paginationActiveItemsNumber.innerHTML = listingProductsNumber.toString()
    if (loadMoreButton) loadMoreButton.dataset.activeItemsNumber = listingProductsNumber.toString()

    if (listingProductsNumber <= totalItemsNumber)
      for (let i = 0; i < listingProductsNumber; i++) {
        if (items[i] || items[i].classList.contains("--hidden")) items[i]?.classList.remove("--hidden")
      }

    if (scrollYValue > 0) {
      window.scrollTo(0, scrollYValue)
    } else {
      section.scrollIntoView({behavior: "smooth", block: "end"})
    }
  }

  if (currentUrl.searchParams.has("limit")) getParamsHandler()

  loadMoreButton?.addEventListener("click", (e) => {
    e.preventDefault()

    const activeItemsNumber = Number(loadMoreButton.dataset.activeItemsNumber)
    const activeItemsStepNumber = Number(loadMoreButton.dataset.activeItemsStepNumber)
    const totalItemsNumber = Number(loadMoreButton.dataset.totalItemsNumber)
    const itemsNumber = activeItemsNumber + activeItemsStepNumber < totalItemsNumber ? activeItemsNumber + activeItemsStepNumber : totalItemsNumber
    loadMoreButton.dataset.activeItemsNumber = itemsNumber.toString()
    if (paginationActiveItemsNumber) paginationActiveItemsNumber.innerHTML = itemsNumber.toString()

    currentUrl.searchParams.set("limit", `${itemsNumber.toString()}`)

    if (itemsNumber >= totalItemsNumber) loadMoreButton.remove()

    for (let i = activeItemsNumber; i < itemsNumber; i++) {
      items[i]?.classList.remove("--hidden")
    }
  })

  window.addEventListener("beforeunload", () => {
    scrollYValue = window.scrollY

    if (scrollYValue > 100) currentUrl.searchParams.set("y", `${scrollYValue}`)
    window.history.replaceState({}, "", currentUrl.toString())
  })
})
